import { render } from "./Customer.vue?vue&type=template&id=b8314afe&scoped=true&lang=pug"
import script from "./Customer.vue?vue&type=script&setup=true&lang=js"
export * from "./Customer.vue?vue&type=script&setup=true&lang=js"

import "./Customer.vue?vue&type=style&index=0&id=b8314afe&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8314afe"]])

export default __exports__